import { InvitationService } from '@/app/services/invitation'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IInvitation, IInvitationCreatePayload } from '@/types/invitation'
import { useMutation, UseMutationOptions } from 'react-query'

export default function useInvitationMutation(
  options?: Omit<
    UseMutationOptions<
      IApiIndividualResponse<IInvitation>,
      ErrorResponse,
      IInvitationCreatePayload
    >,
    'mutationKey' | 'mutationFn'
  >
) {
  return useMutation({
    mutationKey: [InvitationService.RESOURCE_PATH],
    mutationFn: InvitationService.postInvitation,
    ...options,
  })
}
